module.exports = __webpack_public_path__ + "img/Product04.8f17e44b.png";